module.exports = __webpack_public_path__ + "static/media/front.91b2c793.jpg";